module.exports = __webpack_public_path__ + "img/20200518_191439.1d70af5c.jpg";